/** Menu do painel, por área. O nome da rota é o de `router.ts`. */
export interface NavLink {
  name: string;
  label: string;
  /** Destaca o link também em páginas irmãs, quando o caminho começa por isto. */
  activePrefix?: string;
}

export interface NavGroup {
  key: string;
  label: string;
  links: NavLink[];
}

export const NAV_GROUPS: readonly NavGroup[] = [
  {
    key: 'balance',
    label: 'Balanceamento',
    links: [
      { name: 'parameters', label: 'Dano' },
      { name: 'physics', label: 'Arremesso e vento' },
      { name: 'character', label: 'Atributos' },
      { name: 'balls', label: 'Bombas' },
      { name: 'skills', label: 'Habilidades' },
      { name: 'simulator', label: 'Simulador' },
    ],
  },
  {
    key: 'content',
    label: 'Conteúdo',
    links: [
      { name: 'weapons', label: 'Itens', activePrefix: '/itens' },
      { name: 'weapon-visuals', label: 'Visual das armas' },
      { name: 'quests', label: 'Missões' },
    ],
  },
  {
    key: 'game',
    label: 'Operação do jogo',
    links: [
      { name: 'game-characters', label: 'Personagens' },
      { name: 'game-accounts', label: 'Contas' },
      { name: 'game-mail', label: 'Correio' },
      { name: 'game-events', label: 'Eventos' },
    ],
  },
  {
    key: 'audit',
    label: 'Auditoria',
    links: [
      { name: 'history', label: 'Histórico de balanceamento' },
      { name: 'game-audit', label: 'Auditoria do jogo' },
    ],
  },
];
